<template>
  <div>
    <h3 class="d-flex justify-start py-5">{{ $t('export.export_box_content') }}: {{ currentContentExportBox ? currentContentExportBox.name : '' }}</h3>
    <div class="d-flex justify-start">
      <v-chip outlined color="primary" @click="navigateBack">
        <v-icon class="mr-2">
          mdi-arrow-left-circle-outline
        </v-icon>
        {{ $t('export_box_content.back_to_boxes') }}
      </v-chip>
    </div>
    <v-data-table
      :loading="loading"
      :items="exportBoxContent"
      :headers="headers"
      :no-data-text="$t('table_settings.no_data')"
      :loading-text="$t('table_settings.loading_data')"
      :header-props="{
        sortByText: $t('table_settings.sort_by')
      }"
      :footer-props="{
        itemsPerPageAllText: $t('table_settings.all'),
        itemsPerPageOptions: [10, 25, 50, -1],
        itemsPerPageText: $t('table_settings.items_per_page')
        }">
      <template v-slot:[`item.thumbnailFileId`]="{ item }">
        <Thumbnail :fileId="item.thumbnailFileId"></Thumbnail>
      </template>
      <template v-slot:[`item.edit`]="{ item }">
        <v-icon
          small
          @click="deleteItem(item)">
          mdi-delete-outline
        </v-icon>
      </template>
    </v-data-table>
    <v-snackbar v-model="showDeleteErrorSnackbar" color="error">
      {{ $t('common_error.could_not_delete_item') }}
    </v-snackbar>
    <v-snackbar v-model="showLoadingErrorSnackbar" color="error">
      {{ $t('common_error.could_not_load_items')}}
    </v-snackbar>
    <confirm-dialog :show-dialog="this.showConfirmDeleteDialog"
      confirm-color="error"
      :question-text="this.confirmDeleteDialogText"
      :positive-text="$t('common_actions.delete')"
      :negative-text="$t('common_actions.cancel')"
      @onCancel="cancelDeleteItem"
      @onConfirm="confirmDeleteItem">
    </confirm-dialog>
    <div class="mx-10">
      <v-col class="text-right">
        <v-btn fab small color="primary" @click="createExport" absolute>
          <v-icon>mdi-download-outline</v-icon>
        </v-btn>
      </v-col>
    </div>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import Thumbnail from '@/components/common/Thumbnail'

export default {
  components: { Thumbnail, ConfirmDialog },
  name: 'ExportBoxContent',
  data: () => ({
    loading: false,
    showConfirmDeleteDialog: false,
    confirmDeleteDialogText: '',
    showDeleteErrorSnackbar: false,
    showLoadingErrorSnackbar: false,
    editedItem: {
      id: 0,
      index: -1,
      name: ''
    },
    headers: [
      {
        text: i18n.t('artwork.artwork_photo'),
        value: 'thumbnailFileId',
        align: 'start',
        sortable: false
      },
      {
        text: i18n.t('artwork.name'),
        value: 'name',
        align: 'start',
        sortable: true
      },
      {
        text: i18n.t('artwork.evidence_no'),
        value: 'evidenceNumber',
        align: 'start',
        sortable: true
      },
      {
        text: i18n.t('table_settings.delete'),
        align: 'end',
        value: 'edit',
        sortable: false
      }
    ]
  }),
  computed: {
    exportBoxContent () {
      return this.$store.state.exportBoxes.exportBoxContent
    },
    currentContentExportBox () {
      return this.$store.state.exportBoxes.currentContentExportBox
    }
  },
  mounted () {
    if (this.$route.params.exportBox == null) {
      this.$router.push('/Export/BoxList')
      return
    }
    this.loading = true
    this.$store.dispatch('exportBoxes/refreshExportBoxContent', this.$route.params.exportBox).then(result => {
      this.loading = false
    }, _ => {
      this.loading = false
      this.showLoadingErrorSnackbar = true
    })
  },
  methods: {
    navigateBack () {
      this.$router.push('/Export/BoxList')
    },
    createExport () {
      if (this.$store.state.exportBoxes.exportBoxContent.length === 0) {
        this.showNoContentToExportSnackbar = true
        return
      }
      this.$router.push({ name: 'ExportCreate', params: { exportBox: this.currentContentExportBox } })
    },
    cancelDeleteItem () {
      this.showConfirmDeleteDialog = false
    },
    confirmDeleteItem () {
      this.showConfirmDeleteDialog = false
      this.loading = true
      this.$store.dispatch('exportBoxes/removeArtworkFromExportBox', { boxId: this.currentContentExportBox.id, artwork: this.editedItem }).then(result => {
        this.loading = false
      }, _ => {
        this.loading = false
        this.showDeleteErrorSnackbar = true
      })
    },
    deleteItem (item) {
      if (this.loading) {
        return
      }
      this.editedItem.id = item.id
      this.editedItem.name = item.name
      this.editedItem.index = this.exportBoxContent.indexOf(item)
      this.confirmDeleteDialogText = i18n.t('common_actions.confirm_delete') + ' Položka: ' + this.editedItem.name
      this.showConfirmDeleteDialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/exports/ExportBoxContent.vue